// extracted by mini-css-extract-plugin
export default {"integration":"UserIntegration_integration__dxCw2","paymentTypeRow":"UserIntegration_paymentTypeRow__356YT","badge":"UserIntegration_badge__8x9t+"};